import { Stack, Button, Card, Divider, Typography } from "@mui/material";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import __ from "src/utils/Translations";
import { FC } from "react";
import HistoryImportAlert from "src/Pages/Company/OrganizationStructure/sharedComponents/HistoryImportAlert/HistoryImportAlert";
import PreviewImportCard from "src/Pages/Company/OrganizationStructure/sharedComponents/PreviewImportCard/PreviewImportCard";
import useIsAhr from "src/utils/hooks/useIsAhr";
import { useCompanyId } from "src/Pages/Company/CompanyContext";
import { Link } from "react-router-dom";

export interface ImportEntry {
  processData: { id: string };
  fields?: string[];
}

interface IDownloadHistory {
  imports?: ImportEntry[];
}

const DownloadHistory: FC<IDownloadHistory> = ({ imports = [] }) => {
  const isAhr = useIsAhr();
  const companyId = useCompanyId();

  return (
    <Card sx={{ py: 2, px: 3, mt: 2 }} data-testid="os__import-history-section">
      <Stack
        sx={{
          flexDirection: { xs: "column", sm: "row" },
          alignItems: "center",
          gap: 2,
        }}
      >
        <Stack sx={{ flex: 1 }}>
          <Typography
            variant="subtitle1"
            sx={{ fontWeight: 700, textAlign: { xs: "center", sm: "start" } }}
          >
            {__("Historia importów")}
          </Typography>
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ textAlign: { xs: "center", sm: "start" } }}
          >
            {__(
              "Informacje importach i ich statusach znajdziesz w zakładce historia importów"
            )}
          </Typography>
        </Stack>

        <Stack>
          <Button
            color="primary"
            variant="outlined"
            data-testid="os__import-history-navigate-button"
            endIcon={<OpenInNewIcon color="primary" />}
            component={Link}
            to={
              isAhr
                ? `/ahr/imports-history`
                : `/company/edit/${companyId}/imports-history`
            }
          >
            {__("Przejdź do historii importów")}
          </Button>
        </Stack>
      </Stack>

      {imports.length > 0 && (
        <>
          <Divider sx={{ mt: 2 }} />
          <HistoryImportAlert />
          {imports.map((entry) => (
            <PreviewImportCard
              key={entry.processData.id}
              processData={entry.processData}
              fields={entry.fields}
            />
          ))}
        </>
      )}
    </Card>
  );
};

export default DownloadHistory;
